<template>
  <div name="demo-pdf-report-password">
  	pdf report password
  </div>
</template>

<script>
export default {
  name: 'demo-pdf-report-password'
}
</script>


// WEBPACK FOOTER //
// demoPdfReportPassword.vue?9c640ee6